import { Box, styled } from '@mui/material';

const RowWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export default RowWrapper;
